<template>
  <layout-main-inner title="检验报告详情">
    <el-button
      v-if="inspectInfo.status !== 2 && inspectInfo.status !== 9 && inspectInfo.status !== 3"
      slot="action"
      type="primary"
      :loading="loading"
      @click="edit">编辑</el-button>
    <template
      v-if="inspectInfo.needAudit"
      slot="append">
      <el-tag v-if="inspectInfo.status === 1">待提交</el-tag>
      <el-tag
        v-if="inspectInfo.status === 2"
        type="info">审核中</el-tag>
      <el-tag
        v-if="inspectInfo.status === 3"
        type="success">审核通过</el-tag>
      <el-tag
        v-if="inspectInfo.status === 4"
        type="danger">审核不通过({{ inspectInfo.memo }})</el-tag>
      <el-tag
        v-if="inspectInfo.status === 9"
        type="danger">紧急召回</el-tag>
    </template>
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="title">基本信息 </template>
      <inspect-home-form
        v-if="inspectInfo.tradeType === 3"
        ref="form"
        v-model="inspectInfo"
        :isDetail="true" />
      <inspect-outer-form
        v-if="inspectInfo.tradeType === 1"
        ref="form"
        v-model="inspectInfo"
        :isDetail="true" />
    </layout-card-wrap>

    <associate-product
      v-if="inspectInfo.tradeType === 1"
      v-model="inspectInfo"
      :loading="loading"
      :editable="false" />

    <!-- <associate-batch-detail :loading="loading"
      ref="associate"
      :editable="inspectInfo.status === 3 && userPermission.ENT"
      v-model="inspectInfo" /> -->

    <associate-batch
      v-if="inspectInfo.tradeType === 3"
      ref="associate"
      v-model="inspectInfo"
      :loading="loading"
      :editable="false" />

    <template slot="footer">
      <!-- <back-button ref="back" /> -->
      <template v-if="userPermission.SUPERVISE">
        <el-dropdown
          v-if="inspectInfo.status === 2"
          @command="auditinspectreport">
          <el-button
            type="primary"
            style="margin-left:10px"
            :loading="loading">审核<i class="el-icon-arrow-down el-icon--right"></i></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="{passed: 1}">通过</el-dropdown-item>
            <el-dropdown-item :command="{passed: 0}">不通过</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
      <template v-if="userPermission.ENT">
        <!-- <el-button
          v-if="inspectInfo.status !== 2 && inspectInfo.status !== 9 && inspectInfo.status !== 3"
          type="primary"
          :loading="loading"
          @click="edit">编辑</el-button> -->
        <el-button
          v-if="inspectInfo.status === 3"
          type="primary"
          :loading="loading"
          @click="save">更新批次</el-button>
      </template>
      <template v-if="userPermission.OPERATE">
        <el-button
          type="primary"
          :loading="loading"
          @click="edit">编辑</el-button>
      </template>
    </template>
  </layout-main-inner>
</template>
<script>
import InspectHomeForm from './busi/inspect-home-form.vue'
import InspectOuterForm from './busi/inspect-outer-form.vue'
import AssociateBatch from './busi/associate-batch.vue'
import AssociateProduct from './busi/associate-product.vue'
import Utils from './busi/utils.js'
import { mapState } from 'vuex'
export default {
  name: 'InspectDetail',
  components: { InspectHomeForm, InspectOuterForm, AssociateBatch, AssociateProduct },
  props: {},
  data() {
    return {
      loading: false,
      inspectInfo: {}
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission
    })
  },
  mounted() {
    this.getinspectreport({
      vendorId: this.$route.query.vendorId,
      inspectReportId: this.$route.query.inspectReportId
    })
  },
  methods: {
    getinspectreport(config) {
      this.loading = true
      this.$store.dispatch('inspect/getinspectreport', {
        payload: config,
        success: (res) => {
          this.loading = false
          res.data.certFile = res.data.certFile.split(',').map(item => ({ url: item }))

          if (res.data.tradeType === 1) {
            res.data.inspectionFile = res.data.inspectionFile ? res.data.inspectionFile.split(',').map(item => ({ url: item })) : []
            // res.data.shippingTime = res.data.shippingTime ? new Date(res.data.shippingTime) : null
            res.data.customsClearanceTime = res.data.customsClearanceTime ? new Date(res.data.customsClearanceTime) : null
            res.data.inspectReportDetails.forEach(i => {
              const productId = i.productId
              const result = res.data.batchs.filter(s => s.productId === productId)
              i.batchs = result
            })
          } else {
            res.data.inspectionTime = res.data.inspectionTime ? new Date(res.data.inspectionTime) : null
          }
          this.inspectInfo = res.data
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    save() {
      if (this.inspectInfo.tradeType === 1) {
        this.$refs.form.submit((res) => {
          console.log(res)
          if (!Utils.checkData(this.inspectInfo.inspectReportDetails)) {
            this.$message.error('批次商品数量不能大于报检商品数量')
            return
          }
          this.loading = true
          console.log(res)
          this.$store.dispatch('inspect/updateinspectreport', {
            payload: {
              ...res,
              batchIds: Utils.getIds(res)
            },
            success: (res1) => {
              this.loading = false
              if (this.inspectReportAudit === 1 && res.tradeType === 1) {
                this.applyauditinspectreport({
                  vendorId: res.vendorId,
                  inspectReportId: res1.data.inspectReportId
                })
              } else {
                // this.$refs.back.back()
                this.$router.go(-1)
              }
            },
            fail: () => {
              this.loading = false
            }
          })
        })
      } else {
        this.$refs.form.submit((res) => {
          this.loading = true
          console.log(res)
          delete res.inspectReportAudit
          this.$store.dispatch('inspect/updateinspectreport', {
            payload: {
              ...res,
              batchIds: this.$refs.associate.getIds()
            },
            success: () => {
              this.loading = false
              // this.$refs.back.back()
              this.$router.go(-1)
            },
            fail: () => {
              this.loading = false
            }
          })
        })
      }
    },
    edit() {
      this.$router.push(`/inspect-update?vendorId=${this.$route.query.vendorId}&inspectReportId=${this.$route.query.inspectReportId}`)
    },
    auditinspectreport(row) {
      if (row.passed === 0) {
        this.$prompt('请输入说明', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({ value }) => {
          this.loading = true
          this.$store.dispatch('inspect/auditinspectreport', {
            payload: {
              inspectReportId: this.inspectInfo.inspectReportId,
              vendorId: this.inspectInfo.vendorId,
              regulatorId: this.inspectInfo.regulatorId,
              ...row,
              memo: value
            },
            success: () => {
              // this.$refs.back.back()
              this.$router.go(-1)
              this.loading = false
            },
            fail: () => {
              this.loading = false
            }
          })
        })
      } else {
        this.$confirm('是否通过审核?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          this.$store.dispatch('inspect/auditinspectreport', {
            payload: {
              inspectReportId: this.inspectInfo.inspectReportId,
              vendorId: this.inspectInfo.vendorId,
              regulatorId: this.inspectInfo.regulatorId,
              ...row
            },
            success: () => {
              // this.$refs.back.back()
              this.$router.go(-1)
              this.loading = false
            },
            fail: () => {
              this.loading = false
            }
          })
        })
      }
    }
  }
}
</script>
<style lang="stylus"></style>
